// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Qzj6y","title":"styles_title__1tSEl","badges":"styles_badges__bmIHh"};
module.exports.__checksum = "a318699b9dcf"